import {Component, Injectable} from '@angular/core';

@Component({
    template: '<router-outlet></router-outlet>',
    styles: [require('../shared/section/section.component.scss'), require('./licenses-certifications-page.component.scss')]
})
@Injectable()
export class LicensesCertificationsPageComponent {
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/pages/licenses-certifications/licenses-certifications-page.component.ts